
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 9.057V16.5a3 3 0 003 3h12a3 3 0 003-3v-9a3 3 0 00-3-3H6a3 3 0 00-3 3v1.557zM6 6h12a1.5 1.5 0 011.5 1.5v1.11L12 12.648 4.5 8.61V7.5A1.5 1.5 0 016 6zm-1.5 4.314l7.145 3.846a.75.75 0 00.71 0l7.145-3.846V16.5A1.5 1.5 0 0118 18H6a1.5 1.5 0 01-1.5-1.5v-6.186z","fill":"#E53935"}})])
          )
        }
      }
    